var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    viewBox: "0 0 5 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2998 0C2.6111 7.98224e-07 2.89296 0.0697321 3.14551 0.208984C3.39808 0.348336 3.59898 0.547567 3.74707 0.806641C3.89735 1.06582 3.97266 1.37674 3.97266 1.73828V2.43945C4.15963 2.45982 4.30478 2.52213 4.40723 2.62988C4.53564 2.76274 4.59961 2.96687 4.59961 3.24121V5.58301C4.59961 5.86154 4.53549 6.06733 4.40723 6.2002C4.28091 6.33305 4.08978 6.40039 3.83496 6.40039H0.764648C0.509827 6.40039 0.317953 6.33305 0.189453 6.2002C0.0632516 6.06733 0 5.86165 0 5.58301V3.24121C0 2.96679 0.0631316 2.76274 0.189453 2.62988C0.294405 2.5214 0.44166 2.45933 0.630859 2.43945V1.73828C0.630859 1.37674 0.704438 1.06582 0.852539 0.806641C1.00063 0.54757 1.20153 0.348335 1.4541 0.208984C1.70665 0.0697343 1.98851 0 2.2998 0ZM2.2998 0.78125C2.13877 0.78125 1.9929 0.817674 1.8623 0.891602C1.73171 0.965604 1.62722 1.07266 1.54883 1.21191C1.4726 1.3513 1.43359 1.51808 1.43359 1.71191V2.43066H3.16895V1.71191C3.16895 1.51808 3.12919 1.3513 3.05078 1.21191C2.97239 1.07266 2.8679 0.965605 2.7373 0.891602C2.60671 0.817671 2.46084 0.781251 2.2998 0.78125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateDark);
export default __webpack_public_path__ + "static/media/private-dark.0be462fcf366422f23226171456e6cdc.svg";
export { ForwardRef as ReactComponent };